import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { useUserContext } from '../../../Contexts/UserConfig'
import { Avatar, Box, Chip } from '@mui/material'
import { getCodeSetLabelLookup } from '../../../Functions/CodeSetFns'
import * as React from 'react'

export function ScreenManageDGSampleStatusChips({
  value,
  direction = 'column',
}: GridRenderCellParams & { direction?: string }) {
  const { loginConfig } = useUserContext()
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: direction,
      }}
    >
      {value.map((status: any) => (
        <Chip
          color={status.Status === '800' ? 'error' : 'default'}
          key={status.Status}
          sx={{ m: 1 / 3 }}
          label={getCodeSetLabelLookup(
            loginConfig,
            ['SampleStatusID'],
            status.Status,
          )}
          avatar={
            <Avatar
              sx={{
                bgcolor: status.Status === '800' ? 'error.light' : 'default',
                color:
                  status.Status === '800' ? '#FFFFFF !important' : 'default',
              }}
            >
              {status.Total}
            </Avatar>
          }
        />
      ))}
    </Box>
  )
}
